<template>
  <layout title="Contatos da Empresa" :options="options" :rotas="rotas">
    <v-sheet
      :dark="$theme.dark"
      :light="$theme.light"
      class="expande-horizontal sheet-container pt-2"
    >
      <v-flex xs12 class="pr-1" lg3>
        <Filters :filter="filter" />
        <List :filtereds="filtereds" :purpose-label="purposeLabel" />
        <EmptyList
          v-if="filtereds.length === 0"
          :iniciarCadastro="iniciarCadastro"
        />
        <v-fab-transition>
          <v-btn
            @click="iniciarCadastro"
            :color="$theme.primary"
            dark
            absolute
            bottom
            right
            fab
            style="bottom: 30px;"
          >
            <v-icon color="#333">mdi-plus</v-icon>
          </v-btn>
        </v-fab-transition>
      </v-flex>
      <v-flex v-if="$vuetify.breakpoint.lgAndUp" xs12 md9 lg9>
        <ViewForm v-if="get_contato_empresa.new || get_contato_empresa._id" />
      </v-flex>
      <v-dialog
        v-else
        transition="slide-x-transition"
        fullscreen
        :value="get_contato_empresa._id || get_contato_empresa.new ? true : false"
      >
        <v-card>
          <ViewForm />
        </v-card>
      </v-dialog>
    </v-sheet>
  </layout>
</template>

<script>
import EmptyList from "../components/EmptyList.vue";
import Filters from "../components/Filters.vue";
import List from "../components/List.vue";
import ViewForm from "../components/ViewForm.vue";
import { mapActions, mapGetters } from "vuex";

export default {
  components: {
    EmptyList,
    Filters,
    List,
    ViewForm
  },
  data() {
    return {
      filter: {
        search: "",
        purpose: ""
      },
      options: [
        {
          nome: "Novo contato",
          action: this.iniciarCadastro,
          icon: "mdi-plus"
        }
      ],
      rotas: [
        {
          name: "Inicio",
          path: "/dashboard"
        },
        {
          name: "Contatos da Empresa",
          path: "/contatos-empresa"
        }
      ]
    };
  },
  computed: {
    ...mapGetters(["get_contato_empresa", "get_contatos_empresa"]),
    filtereds() {
      const docs = this.get_contatos_empresa.docs || [];
      const term = (this.filter.search || "").toLowerCase();
      return docs.filter(item => {
        const matchesSearch = !term ||
          (item.label && item.label.toLowerCase().includes(term)) ||
          (item.phone && item.phone.toLowerCase().includes(term)) ||
          (item.phone_normalized && item.phone_normalized.includes(term)) ||
          (item.unity && item.unity.nome && item.unity.nome.toLowerCase().includes(term)) ||
          (item.responsible_user && item.responsible_user.nome && item.responsible_user.nome.toLowerCase().includes(term));
        const matchesPurpose = !this.filter.purpose || item.purpose === this.filter.purpose;
        return matchesSearch && matchesPurpose;
      });
    }
  },
  methods: {
    ...mapActions([
      "listar_contatos_empresa",
      "listar_opcoes_contatos_empresa",
      "setPersonalizedLoading"
    ]),
    iniciarCadastro() {
      this.setPersonalizedLoading("animate__fadeOutTopRight");
      this.$store.commit("set_contato_empresa", {
        new: true,
        active: true,
        purpose: "delivery"
      });
      this.setPersonalizedLoading("animate__fadeInUp");
    },
    purposeLabel(purpose) {
      return {
        delivery: "Entregas",
        sale_follow_up: "Acompanhamento",
        budget_owner: "Responsavel por orcamentos"
      }[purpose] || "Sem finalidade";
    }
  },
  created() {
    this.listar_opcoes_contatos_empresa();
    this.listar_contatos_empresa();
  }
};
</script>

<style scoped>
.sheet-container {
  min-height: 95vh;
  max-height: 95vh;
  overflow: hidden;
}
</style>
